<template>
  <div class="image" v-on="$listeners">
    <no-ssr>
      <img
        v-lazy="{src: image, loading: '/assets/mstile-150x150.png', error: '/assets/mstile-150x150.png'}"
        :alt="alt"
        key="image"
        ref="images"
        itemprop="image"
        class="image__thumb"
      >
    </no-ssr>
  </div>
</template>

<script>
import config from 'config';
import NoSSR from 'vue-no-ssr';
import { onlineHelper } from '@vue-storefront/core/helpers';

export default {
  components: {
    'no-ssr': NoSSR
  },
  props: {
    thumbnailSize: {
      type: String,
      default: '175'
    },
    thumbnailPath: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showPlaceholder: true,
      showImage: false,
      image: ''
    };
  },
  mounted () {
    if (!this.thumbnailPath) {
      this.image = '';
    } else {
      if (this.thumbnailPath.startsWith("http")) {
        this.image = this.thumbnailPath
      } else {
        this.image =
          config.cloudfront.host +
          '' +
          config.cloudfront.id +
          '/' +
          this.thumbnailSize +
          '/' +
          this.thumbnailPath;
      }
    }
  },
  methods: {
    imageLoaded () {
      this.showPlaceholder = false;
      this.showImage = true;
    },
    loadPlaceholder () {
      this.showPlaceholder = true;
      this.showImage = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.image {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: calc(100%);
  overflow: hidden;
  mix-blend-mode: multiply;
  &__thumb {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    transform: translate3d(-50%, -50%, 0);
    &--placeholder {
      width: auto;
      height: auto;
    }
  }
}
</style>
